export default "__VITE_ASSET__ZVEIEMQZ__"